import { isApiUserEmail } from '@mls-wallet/shared-types';

export type User = {
  id: string;
  name: string;
  email: string;
  organizationId: string | null;
  createdAt: Date;
  updatedAt: Date;
};

export type MinimalUser = {
  id: string;
  name: string;
  email: string;
};

/**
 * Organization member type used across the frontend.
 */
export type OrganizationMember = Pick<User, 'id' | 'name' | 'email'>;

// Display text shown in UI for API users instead of their fake email
const API_USER_DISPLAY_TEXT = 'API User';

/**
 * Returns display text for an email - "API User" for API users, actual email otherwise.
 * Use this wherever member emails are displayed in the UI.
 */
export function getEmailDisplay(email: string): string {
  return isApiUserEmail(email) ? API_USER_DISPLAY_TEXT : email;
}
